import { ImagesSubComponent } from '../images.sub.component';
import { createLightbox } from '../../../_common/client/nexus-interfaces/lightbox';
import { LightboxOptions } from '../../../lightbox/client/lightbox/lightbox';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class LightboxSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_images';

    private zoomImageTrackingDone = false;

    protected onItemChanged(): void {
        return;
    }

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        await this.initPhotoSwipeLightBox();
    }

    private async initPhotoSwipeLightBox() {
        const options: LightboxOptions = {
            gallery: '.js_pdp_main-image',
            children: '.js_pdp_main-image__slide-content--zoomable',
            thumbSelector: 'img',
            onOpen: () => {
                trackEvent({
                    product_Zoom: ['open'],
                });
            },
            onChange: (index, _, direction) => {
                trackEvent({
                    product_Zoom: ['change_image'],
                    product_ZoomDirection: [direction],
                });
                this.changeItem(this.toFullIndex(index));
            },
            onClose: () => {
                trackEvent({
                    product_Zoom: ['close'],
                });
            },
            onZoom: () => {
                if (!this.zoomImageTrackingDone) {
                    this.zoomImageTrackingDone = true;
                    trackEvent({
                        product_Zoom: ['zoom_image'],
                    });
                }
            },
        };

        await createLightbox(options);
    }
}
